export default "__VITE_ASSET__BirPQL7e__"